/**
 * This hook provides an efficient way to fetch data from the server. 
 * All components share the same data source. The request is made only once. 
 * The data is cached in the browser. If the data is fetched again, the 
 * cached data is used to render the component while the request is in 
 * progress. After which the fresh data is used to rerender the component.
 * 
 * TODO: implement order param
 * TODO: implement orderBy param
 * TODO: implement page param
 * TODO: implement perPage param
 * TODO: implement search param
 * TODO: implement categories param
 * TODO: implement embed param

 */

import { useEffect, useMemo } from 'react'

import useSWRInfinite from 'swr/infinite'

//convert types array to search params sting
const typesToParams = (types) => {
    if (!types || !types.length) return ''
    return types.map(type => `type[]=${type}`).join('&')
}


/** convert active terms to search params string */
const activeTermsToParams = (activeTerms = {}) => {
    const entries = Object.entries(activeTerms)
    if (!entries.length) return ''

    const params = []
    for (const [taxonomy, terms] of Object.entries(activeTerms)) {
        if (!terms.length) continue
        params.push(`${taxonomy}=${terms.join(',')}`)
    }

    return params.length > 0 ? params.join('&') : ''
}

const getUrl = ({
    types = ['post'],
    perPage,
    page,
    order,
    orderBy,
    fields,
    embed,
    pathname,
    base,
    categories,
    activeTerms,
}) => {

    const url = new URL(pathname, base)
    if (perPage) url.searchParams.set('per_page', perPage)
    if (page) url.searchParams.set('page', page)
    if (order) url.searchParams.set('order', order)
    if (orderBy) url.searchParams.set('order_by', orderBy)
    if (categories && categories.length > 0) {
        url.searchParams.set('categories', categories)
    }
    if (Array.isArray(fields)) url.searchParams.set('_fields', fields.join(','))
    if (embed) url.searchParams.set('_embed', Array.isArray(embed) ? embed.join(",") : embed)
    for (const type of types) {
        url.searchParams.append('type[]', type)
    }

    url.searchParams.sort()
    // append active terms to search params
    url.search += `&${activeTermsToParams(activeTerms)}`

    console.log('swr url', url.href)
    return url.href
}

const fetcher = (props) => {
    const url = getUrl(props)
    return fetch(url).then(res => res.json())
}



export const usePosts = ({
    perPage = 10,
    fields = [],
    orderBy,
    order,
    types = ['post'],
    embed = true,
    page,
    pathname = `/wp-json/wp/v2/postsbytype`,
    base = window.location.origin,
    categories = [],
    searchTerms = '',
    activeTerms = {},
} = {}) => {
    const getKey = (pageIndex, previousPageData) => {
        if (previousPageData && !previousPageData.length) return null
        return {
            pathname,
            base,
            page: pageIndex + 1,
            types,
            perPage,
            fields,
            orderBy,
            order,
            embed,
            categories,
            searchTerms,
            activeTerms
        }
    }
    const {
        data,
        error,
        isValidating,
        mutate,
        size,
        setSize
    } = useSWRInfinite(
        getKey,
        fetcher,
        {
            // refreshInterval: 0,
            revalidateIfStale: true,
            // revalidateOnFocus: false,
            // revalidateOnReconnect: false,
            // revalidateOnWindowFocus: false,
            revalidateOnMount: true,
            // initialSize: page,
            // onFailure() {
            //     localStorage.removeItem(getUrl({
            //         pathname,
            //         base,
            //         page: size,
            //         types,
            //         perPage,
            //         fields,
            //         orderBy,
            //         order,
            //         embed,
            //     }))
            // },
            // onSuccess(data) {
            //     console.log('size on success', size)
            //     localStorage.setItem(getKey({
            //         pathname,
            //         base,
            //         page: size,
            //         types,
            //         perPage,
            //         fields,
            //         orderBy,
            //         order,
            //         embed,
            //     }), JSON.stringify(data))
            // }
        }
    )

    // useEffect(() => {
    //     // get data from localStorage
    //     const data = localStorage.getItem(getUrl({
    //         pathname,
    //         base,
    //         page: size,
    //         types,
    //         perPage,
    //         fields,
    //         orderBy,
    //         order,
    //         embed,
    //     }))
    //     if (data) {
    //         mutate(JSON.parse(data), false)
    //     }
    // }, [])

    return {
        postsData: data,
        isPostsLoading: !data && !error,
        isPostsError: error && !data,
        isPostsValidating: isValidating,
        mutatePosts: mutate,
        postsPageSize: size,
        setPostsPageSize: setSize
    }
}

export default usePosts;


